import { render, staticRenderFns } from "./CDept.vue?vue&type=template&id=fce8dd70"
import script from "./CDept.vue?vue&type=script&lang=js"
export * from "./CDept.vue?vue&type=script&lang=js"
import style0 from "./CDept.vue?vue&type=style&index=0&id=fce8dd70&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce8dd70')) {
      api.createRecord('fce8dd70', component.options)
    } else {
      api.reload('fce8dd70', component.options)
    }
    module.hot.accept("./CDept.vue?vue&type=template&id=fce8dd70", function () {
      api.rerender('fce8dd70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CDept.vue"
export default component.exports